import { API_ROOT } from '../../../../config/envUrl';

export const getUrlImageBrochureOverlay = apiUrl => {
  let url =
    API_ROOT.replace(/(\r\n|\n|\r)/gm, '') +
    apiUrl.replace(/(\r\n|\n|\r)/gm, '');
  return url;
};
